module.exports = __webpack_public_path__ + "static/headerRightBg375-4221d23e96a4b1b064155c9a34d448a4.png";